import axios, { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import stores from '../../stores'

const PRP_2BOX_API_URL = process.env.REACT_APP_PRP_2BOX_API as string

const prp2boxHttp = axios.create({
  baseURL: PRP_2BOX_API_URL,
  timeout: 10000,
})

prp2boxHttp.interceptors.request.use(
  (config) => {
    const { accessToken } = stores.loginStore

    if (accessToken) {
      // eslint-disable-next-line no-param-reassign
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
      }
    }

    return config
  },
  (error) => error
)

prp2boxHttp.interceptors.response.use(
  (response) => response,
  async (err: AxiosError) => {
    const errorMessage =
      err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
    toast.error(errorMessage)
    return Promise.reject(err)
  }
)

export default prp2boxHttp
